import React from 'react';

const DisplayImage = ({ file }) => {
    return (
        <div className="display-image-container">
            <img
                src={file.src || file}
                alt={file.name || 'image'}
                className="display-image"
            />
        </div>
    );
};

export default DisplayImage;
